module.exports = __webpack_public_path__ + "img/affirmative action burrss.a5f5a8db.png";